export class StrongoDepartment {
    public id: number;
    public company_id: number;
    public name: string;
    public code: string;
    public is_active: boolean;

    constructor(data?: StrongoDepartmentData) {
        if (!data) {
            this.id = 0;
            this.company_id = 0;
            this.name = "";
            this.code = "";
            this.is_active = true;
        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.name = data.name;
            this.code = data.code;
            this.is_active = data.is_active;
        }
    }

    serializeData(): StrongoDepartmentData {
        return {
            id: this.id,
            company_id: this.company_id,
            name: this.name,
            code: this.code,
            is_active: this.is_active,
        };
    }
}

export type StrongoDepartmentData = {
    id: number;
    company_id: number;
    name: string;
    code: string;
    is_active: boolean;
};
